export default "https://assets.egbcdn.net/assets/packs/_/images/app/manual/manual3-e8193ff1575f794d51a3beb9d100adb7.png";